<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="员工信息" prop="userInfo">
                        <el-input style="width: 232px" v-model="searchForm.employeeInfo" placeholder="请输入员工信息"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="授权时间" prop="inTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="登录时间" prop="lastActiveTimeStart">
                        <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="状态" prop="brandId">
                        <el-select v-model="searchForm.status" placeholder="请选择状态" style="width: 232px" filterable
                            clearable>
                            <el-option label="在职" value="1"></el-option>
                            <el-option label="离职" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" style="width:92px;height: 36px;" @click="add">添加</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="添加员工" :visible.sync="isAdd" width="487px" :append-to-body="true" :close-on-click-modal="false">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="small" class="ruleForm">
                    <el-form-item label="添加手机号" prop="phone">
                        <el-input v-model="ruleForm.phone" placeholder="请输入手机号" :maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="再次确认" prop="again">
                        <el-input v-model="ruleForm.again" placeholder="请再次输入手机号" :maxlength="11"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isAdd = false">取消</div>
                <div class="info-s" @click="addSubmit">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="编辑员工" :visible.sync="isEdit" width="487px" :append-to-body="true" :close-on-click-modal="false">
            <div>
                <el-form label-width="100px" size="small" class="ruleForm">
                    <el-form-item label="姓名">
                        {{ userName }}
                    </el-form-item>
                    <el-form-item label="ID">
                        {{ userId }}
                    </el-form-item>
                    <el-form-item label="手机号码">
                        {{ phone }}
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-radio v-model="radio" label="1">在职</el-radio>
                        <el-radio v-model="radio" label="2">离职</el-radio>
                    </el-form-item>
                </el-form>
            </div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isEdit = false">取消</div>
                <div class="info-s" @click="updateStatus">确定</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
    },
    data() {
        var validatePhone = async (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                    callback(new Error('请输入正确手机号'));
                } else {
                    await this.axios.get('/employee/checkPhone?phone=' + value).then(res => {
                        if (res.code == 0) {
                            console.log(res.data)
                            if (res.data == false) {
                                callback(new Error('该手机号已添加为员工，请重新输入'));
                            }
                        }
                    })
                }
                callback();
            }
        };

        var validateAgain = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入手机号'));
            } else {
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                    callback(new Error('请输入正确手机号'));
                } else {
                    if (this.ruleForm.phone != value) {
                        callback(new Error('输入手机号不一致，请重新输入'));
                    }
                }
                callback();
            }
        };
        return {
            id: '',
            radio: '1',
            ruleForm: {
                phone: '',
                again: '',
            },
            rules: {
                phone: [
                    { required: true, validator: validatePhone, trigger: 'blur', },
                    // { min: 1, max: 11, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                again: [
                    { required: true, validator: validateAgain, trigger: 'blur' }
                ]
            },
            isEdit: false,
            isAdd: false,
            dataList: {
                list: [
                    { title: '系统管理', path: '', type: '0' },
                    { title: '员工管理', path: '/systemManagement/memberManagement', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '员工管理', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                lastActiveTimeStart: '', // 
                lastActiveTimeEnd: '',
                employeeInfo: '', // 	
                inTimeStart: '', // 	
                inTimeEnd: '', // 	
                pageNo: 1,
                pageSize: 10,
                status: null
            },
            value1: [],
            value2: [],
            stars: [

            ],
            columns: [
                {
                    label: '序列', minWidth: '80', prop: 'index',
                    render: (h, scope) => {
                        return (
                            <div>{scope.$index + 1}</div>
                        )
                    }
                },
                {
                    label: '员工信息', prop: 'username', minWidth: '300',
                    renderHeader: (h, scope) => {
                        return (
                            <div style="text-align:left">员工信息</div>
                        )
                    },
                    render: (h, scope) => {
                        let img = scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')
                        return (
                            <div style="display:flex">
                                <div>
                                    <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
                                </div>
                                <div style="margin-left:8px">
                                    <div style="text-align:left">昵称：{scope.row.userName || '--'}</div>
                                    <div style="text-align:left">ID：{scope.row.userId || '--'}</div>
                                    <div style="text-align:left">电话：{scope.row.phone || '--'}</div>
                                </div>

                            </div>
                        )
                    }
                },
                {
                    label: '授权时间', prop: 'inTime', minWidth: '200',
                    renderHeader: (h, scope) => {
                        return (
                            <div style="text-align:left">授权时间</div>
                        )
                    },
                    render: (h, scope) => {
                        return (
                            <div style="text-align:left">{scope.row.inTime || '--'}</div>
                        )
                    }
                },
                {
                    label: '状态', prop: 'goodsName', minWidth: '220',
                    render: (h, scope) => {
                        let v = ''
                        if (scope.row.status == 2) {
                            v = <span style='color:red'>{scope.row.statusLabel}</span>
                        } else {
                            v = <span>{scope.row.statusLabel}</span>
                        }
                        return (
                            <div>
                                {v}
                            </div>
                        )
                    }
                },
                {
                    label: '操作',
                    minWidth: '100',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.toEdit(scope.row) }}>编辑</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            exporting: false,
            isName: '',
            cId: '',
            showFlag: '',
            userName: '',
            userId: '',
            phone: '',
            status: ''
        }
    },
    created() {
        // this.getPageList()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addComment') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        addSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let data = {
                        phone: this.ruleForm.phone
                    }
                    this.axios.post('/employee/add', data).then(res => {
                        if (res.code == 0) {
                            this.$message.success('添加成功')
                            this.isAdd = false
                            this.getPageList()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        add() {
            this.isAdd = true
            this.ruleForm.phone = ''
            this.ruleForm.again = ''
            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields()
            })

        },
        updateStatus() {
            let data = {
                id: this.id,
                status: Number(this.radio)
            }
            this.axios.post('/employee/edit', data).then(res => {
                if (res.code == 0) {
                    this.$message.success('更改成功')
                    this.isEdit = false
                    this.getPageList()
                }
            })
        },
        isShow(row) {
            this.isS = true
            this.isName = row.statusL
            this.cId = row.id
            console.log(row.showFlag)
            this.showFlag = !row.showFlag
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                })
                this.value1 = []
                this.value2 = []
                this.searchForm.inTimeStart = ''
                this.searchForm.inTimeEnd = ''
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
                this.searchForm.employeeInfo = ''
                this.searchForm.userInfo = ''
                this.searchForm.status = null
            }
            this.getPageList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.inTimeStart = this.value1[0];
                this.searchForm.inTimeEnd = this.value1[1];
            } else {
                this.searchForm.inTimeStart = ''
                this.searchForm.inTimeEnd = ''
            }
            if (this.value2 && this.value2.length > 0) {
                this.searchForm.lastActiveTimeStart = this.value2[0];
                this.searchForm.lastActiveTimeEnd = this.value2[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/employee/pageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.list = res.data.list;
                        this.page.totalNum = res.data.totalNum;
                    }
                })
        },
        onMultipleSelection(e) { },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        toEdit(row) {
            this.isEdit = true
            // this.$nextTick(() => {
            //     this.$refs['ruleForm'].resetFields()
            // })
            console.log(row)
            this.userName = row.userName || '--'
            this.userId = row.userId || '--'
            this.phone = row.phone || '--'
            this.radio = String(row.status)
            this.id = row.id
        }
    }
}
</script>
  
<style scoped lang="scss">
.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  